import { render, staticRenderFns } from "./FluxCaption.vue?vue&type=template&id=fd3a995a&"
import script from "./FluxCaption.vue?vue&type=script&lang=js&"
export * from "./FluxCaption.vue?vue&type=script&lang=js&"
import style0 from "./FluxCaption.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports